
import React from 'react';
import { AiFillEnvironment, AiTwotoneMail, AiFillPhone } from 'react-icons/ai'
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineEmail } from "react-icons/md";
import InputBox from './Components/InputBox';

function Contact() {
  return (
    <div className="flex flex-col w-full px-5 md:px-10 mt-20">
      <div className="flex flex-col items-center gap-4">
        <p className="text-3xl text-slate-800 font-bold leading-relaxed">
          Get In Touch!
        </p>
        <div className="h-1 w-44 bg-orange-500 rounded-xl"> 

</div>

        <p>
          We will be delighted to help you. Feel free to reach out.
        </p>
      </div>
      <div className="flex flex-col my-8 mx-6 gap-8">

        <div className="flex md:flex-row gap-4 md:gap-0 flex-col-reverse">
          <div className="bg-slate-100 w-full">
            <form className="flex flex-col px-6 w-full">
              <div className="grid grid-cols-2 gap-4 w-full">

                <InputBox placeholder={"Full Name"} type="text" />
                <InputBox placeholder={"E-Mail"} type="email" />
              </div>
              <div className="grid grid-cols-2 gap-4">

                <InputBox placeholder={"Batch"} type="number" />
                <InputBox placeholder={"Phone No."} type="tel" pattern="[0-9]{5}-[0-9]{5}" />
              </div>
              <InputBox placeholder={"Message"} type="text" />


              <button className="py-2 bg-blue-900 text-white mb-4 font-semibold text-xl rounded-md">
                Send
              </button>

            </form>



          </div>
          <div className="w-full">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14249.341967536793!2d75.84490968560985!3d26.765573732373646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c1c7f8fffffff%3A0x7ee5a5f5b127bb8d!2sPoornima%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1657013602429!5m2!1sen!2sin" className="w-full md:h-full h-96" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
          </div>

        </div>
      </div>
      <div className="grid md:grid-cols-3 text-white mb-20 md:px-0 grid-cols-1 px-6 w-full gap-8 items-center">
        <div className="bg-slate-400 p-2 rounded-lg">
          <div className="flex flex-row gap-2 text-lg font-semibold">
            <AiFillEnvironment size={26} />
            <p>
              ADDRESS
            </p>
          </div>
          <p>
            PCAS Office,
            Poornima College
            of Engineering
            Jaipur (Raj.)
          </p>

        </div>
        <div className="bg-slate-400 p-2 rounded-lg">
          <div className="flex flex-row gap-2 text-lg font-semibold">
            <MdOutlineEmail size={26} />
            <p>
              EMAIL
            </p>
          </div>
          <p>
            alumnirelations.pce@poornima.org
          </p>

        </div>


        <div className="bg-slate-400 p-2 rounded-lg">
          <div className="flex flex-row gap-2 text-lg font-semibold">
            <BiPhoneCall size={26} />
            <p>
              CALL US
            </p>
          </div> 
          <p>
            +91 73000 66682
          </p>

        </div>


      </div>

    </div>

  );
}

export default Contact;
